import { create } from 'zustand';

export interface DonchianSettings {
  enabled: boolean;
  entryLookback: number;
  trendLookback: number;
  exitLookback: number;
  volumeMultiplier: number;
  volumeLookback: number;
  requireTrendFilter: boolean;
}

const DEFAULTS: DonchianSettings = {
  enabled: true,
  entryLookback: 20,
  trendLookback: 55,
  exitLookback: 10,
  volumeMultiplier: 1.5,
  volumeLookback: 10,
  requireTrendFilter: true,
};

interface DonchianSettingsState {
  settings: DonchianSettings;
  setSettings: (s: DonchianSettings) => void;
  loaded: boolean;
  setLoaded: (v: boolean) => void;
}

export const useDonchianSettingsStore = create<DonchianSettingsState>((set) => ({
  settings: DEFAULTS,
  setSettings: (settings) => set({ settings, loaded: true }),
  loaded: false,
  setLoaded: (loaded) => set({ loaded }),
}));
